import {
  getApiRoot,
  getAppClientId,
  getRedirectState,
  getRedirectUri,
} from "../@api/config";
import { getJsonResponse } from "../@api/jsonResponse";

interface AuthCodeResponse {
  redirect_uri: string;
}

export const authorizeGet = (
  userId: string,
  accessToken: string,
): Promise<AuthCodeResponse> =>
  fetch(
    `${getApiRoot()}/user/${userId}/authorize?response_type=code` +
      `&client_id=${getAppClientId()}` +
      `&state=${getRedirectState()}` +
      `&redirect_uri=${getRedirectUri()}`,
    {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${accessToken}`,
      },
    },
  ).then(getJsonResponse);
